import { Loca_setTimeline } from './Loca.setTimeline'
import { Logg_event } from '../Logg/Logg.event'
import Store from '../../src/stores/location'

export async function Loca_updateCurrentTimeline() {
    Logg_event('Start', { label: 'location.updateCurrentTimeline' })

    if (Store.getSelectedLocation()) {
        Loca_setTimeline(Store.getSelectedLocation().id)
    }
}
